import { render, staticRenderFns } from "./digitalAllData.vue?vue&type=template&id=6ba80ca5&scoped=true"
import script from "./digitalAllData.vue?vue&type=script&lang=js"
export * from "./digitalAllData.vue?vue&type=script&lang=js"
import style0 from "./digitalAllData.vue?vue&type=style&index=0&id=6ba80ca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba80ca5",
  null
  
)

export default component.exports